import {useContext} from "react";
import AuthenticationContext from "./auth-context";

const useAuth = () => useContext(AuthenticationContext);
export default useAuth;
